import { Component, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Pacchetti from "@/pages/Pacchetti";
import DettaglioPacchetto from "@/pages/DettaglioPacchetto";
import Carrello from "@/pages/Carrello";
import Grazie from "@/pages/Grazie";
import ChiSiamo from "@/pages/ChiSiamo";
import CalcolatoreROI from "@/pages/CalcolatoreROI";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(err) {
    console.error("Boundary caught:", err);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-ink text-center">
          <div>
            <p className="font-display text-3xl font-bold text-white">Qualcosa è andato storto</p>
            <button
              onClick={() => window.location.reload()}
              className="mt-6 rounded-full bg-electric px-6 py-3 text-sm font-bold text-ink"
            >
              Ricarica la pagina
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SmoothScroll = ({ children }) => {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return children;
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <SmoothScroll>
          <CartProvider>
            <ScrollToTop />
            <div className="grain relative min-h-screen bg-ink">
              <Navbar />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/pacchetti" element={<Pacchetti />} />
                  <Route path="/pacchetti/:slug" element={<DettaglioPacchetto />} />
                  <Route path="/calcolatore-roi" element={<CalcolatoreROI />} />
                  <Route path="/chi-siamo" element={<ChiSiamo />} />
                  <Route path="/carrello" element={<Carrello />} />
                  <Route path="/grazie" element={<Grazie />} />
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
              <Footer />
            </div>
            <Toaster position="bottom-right" richColors theme="dark" />
          </CartProvider>
        </SmoothScroll>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
